import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "@/services/authService";
import ROUTES from "@/data/Routes";
import Container from "@/components/Container";
import { useAuth } from "@/data/context/authContext";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { loadUser } = useAuth();
  const [status, setStatus] = useState<"pending" | "success" | "error">(
    "pending",
  );
  const [message, setMessage] = useState<string>(
    "Patvirtiname jūsų el. paštą…",
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const hash = params.get("hash");
    if (!id || !hash) {
      setStatus("error");
      setMessage("Trūksta patvirtinimo duomenų.");
      navigate(ROUTES.HOME);
      return;
    }

    (async () => {
      try {
        await authService.verifyEmail(id, hash);
        await loadUser();
        setStatus("success");
        setMessage("El. paštas patvirtintas. Nukreipiame…");
      } catch (e: any) {
        setStatus("error");
        setMessage(
          e?.response?.data?.message || "Nepavyko patvirtinti el. pašto.",
        );
      } finally {
        navigate(ROUTES.REGISTER);
      }
    })();
  }, [navigate]);

  return (
    <Container className="mt-8 mb-8 px-4">
      <div
        className="mb-6 rounded-lg border p-4"
        style={{
          borderColor:
            status === "success"
              ? "#86efac"
              : status === "error"
                ? "#fca5a5"
                : "#e5e7eb",
          background:
            status === "success"
              ? "#ecfdf5"
              : status === "error"
                ? "#fef2f2"
                : "#f9fafb",
          color: "#111827",
        }}
      >
        {message}
      </div>
    </Container>
  );
};

export default VerifyEmail;
